import axios from 'axios'
import {$authToken, setToken, setUserId} from "../Hooks/useAuth";

export const instance = axios.create({
    baseURL: 'https://api.exhot.ru/api',
    timeout: 10000,
});
instance.interceptors.request.use((req)=>{
    //@ts-ignore
    req.headers = {...req.headers, 'Authorization': `Bearer ${$authToken.getState()}`}
    return req
})

export async function sendMessage(content:string) {
    const data = {
        content: content
    }

    const res = await instance.post('/chat', data);

    if(res.data?.success){
        return true;
    }
}
export async function setUserIdForSocket() {
    const res = await instance.get('/user');

    if(res.data?.id){
        setUserId(res.data.id)
    }
}
